<template>
  <v-progress-linear
    v-if="progress"
    fixed
    top
    v-model="progress"
    color="pink"
    style="z-index: 800;"
  ></v-progress-linear>
</template>

<script>
export default {
  data() {
    return {
      progress: 0
    }
  },
  created() {
    this.$root.$on('progress-linear', this.setValue)
  },
  beforeDestroy() {
    this.$root.$off('progress-linear')
  },
  methods: {
    setValue(value) {
      this.progress = value
    }
  }
}
</script>